import React, { useState } from 'react';
import OAuth2Login from './OAuth2Login';
import ErrorAlert from './ErrorAlert';
import {
  authorizationUrl,
  clientId,
  redirectUri,
  appServerUrl,
  oauthServerUrl,
  scope,
} from './settings-sample';

export default function AuthorizationCodeExample() {
  const [accessToken, setAccessToken] = useState(null);
  const [user, setUser] = useState(null);
  const [error, setError] = useState(null);

  // You can test this with a GitHub OAuth2 app (provided test server supports GitHub and Spotify)
  const onSuccess = ({ code }) => {
    let widget = document.createElement("script");
    widget.type = "text/javascript";
    widget.charset = "utf-8";
    widget.innerHTML = "(function (g, e, n, es, ys) {g['_genesysJs'] = e;g[e] = g[e] || function () {(g[e].q = g[e].q || []).push(arguments)};g[e].t = 1 * new Date();g[e].c = es;ys = document.createElement('script'); ys.async = 1; ys.src = n; ys.charset = 'utf-8'; document.head.appendChild(ys);})(window, 'Genesys', 'https://apps.mypurecloud.de/genesys-bootstrap/genesys.min.js', {environment: 'euc1',deploymentId: '102fe28f-7295-4452-868d-d076813fedb0'});Genesys('registerPlugin', 'AuthProvider', (AuthProvider) => {AuthProvider.registerCommand('getAuthCode', (e) => {e.resolve({authCode: \""+code+"\",redirectUri: \"https://master.dj5dq9npte6en.amplifyapp.com/\",codeVerifier:\"67f4f1ed232ba9ca97b83f195e0e73032526db5690792143155e46ab\" });});AuthProvider.registerCommand('reAuthenticate', (e) => {e.resolve();});AuthProvider.subscribe('Auth.loggedOut', () => {console.log(\"Genesys logout\");});AuthProvider.subscribe('Auth.authError', (error) => {console.error(\"Genesys Auth Error: \", error);});AuthProvider.subscribe('Auth.error', (error) => {console.error(\"Genesys Auth Error: \", error);});AuthProvider.ready();});"
    document.body.appendChild(widget);
  }
  return (
    <div className="column">
      {
        error && <ErrorAlert error={error} />
      }
      <OAuth2Login
        id="auth-code-login-btn"
        authorizationUrl={authorizationUrl}
        clientId={clientId}
        redirectUri={redirectUri}
        responseType="code"
        responseMode="fragment"
        scope={scope}
        buttonText="Auth code login"
        onSuccess={onSuccess}
        onFailure={setError}
        isCrossOrigin= {false}
        codeChallengeMethod="S256"
        codeChallenge="v5_aNW803eMAx9617rm-Hfh7AICAtxdIgkGCCjH2GPw"
      />
      {
        accessToken && <p>Access token: {accessToken}</p>
      }
      {
        user && (
          <div>
            <h3>User data</h3>
            <p>Obtained from token-protected API</p>
            <p>{user.name} {user.email}</p>
            <img src={user.picture} alt={user.name} />
          </div>
        )
      }
    </div>
  );
}

/*
response_type=code
client_id=ee23066a-1088-43ca-b3e2-d2da7d5636a6
scope=openid%20profile%20email%20offline_access%20phone
redirect_uri=https%3A%2F%2Fmaster.dj5dq9npte6en.amplifyapp.com%2F
prompt=login
code_challenge_method=S256
code_challenge=4Q5RHaZsDYxjkL8MAuo0z1zGfMpEsPb-QYw6EEY0VUw
*/

/*
    let widget = document.createElement("script");
    widget.type = "text/javascript";
    widget.charset = "utf-8";
    widget.innerHTML = "(function (g, e, n, es, ys) {g['_genesysJs'] = e;g[e] = g[e] || function () {(g[e].q = g[e].q || []).push(arguments)};g[e].t = 1 * new Date();g[e].c = es;ys = document.createElement('script'); ys.async = 1; ys.src = n; ys.charset = 'utf-8'; document.head.appendChild(ys);})(window, 'Genesys', 'https://apps.mypurecloud.de/genesys-bootstrap/genesys.min.js', {environment: 'euc1',deploymentId: '102fe28f-7295-4452-868d-d076813fedb0'});Genesys('registerPlugin', 'AuthProvider', (AuthProvider) => {AuthProvider.registerCommand('getAuthCode', (e) => {e.resolve({authCode: \""+code+"\",redirectUri: \"https%3A%2F%2Fmaster.dj5dq9npte6en.amplifyapp.com%2F\",codeVerifier:\"67f4f1ed232ba9ca97b83f195e0e73032526db5690792143155e46ab\" });});AuthProvider.registerCommand('reAuthenticate', (e) => {e.resolve();});AuthProvider.subscribe('Auth.loggedOut', () => {console.log(\"Genesys logout\");});AuthProvider.subscribe('Auth.authError', (error) => {console.error(\"Genesys Auth Error: \", error);});AuthProvider.subscribe('Auth.error', (error) => {console.error(\"Genesys Auth Error: \", error);});AuthProvider.ready();});"
    document.body.appendChild(widget);
*/